import React, { ReactNode } from 'react';

import { TranslationConfig } from '../types';
import { TranslationsContext } from './TranslationsContext';

export interface TranslationsProviderProps {
    children: ReactNode;
    value?: TranslationConfig;
    instanceLanguages?: string[];
    instanceDefaultLanguage: string;
}

const TranslationsProvider: React.FC<TranslationsProviderProps> = ({
    children,
    value,
    instanceDefaultLanguage,
    instanceLanguages,
}) => {
    if (!value) {
        return null;
    }

    return (
        <TranslationsContext.Provider
            // eslint-disable-next-line react/jsx-no-constructed-context-values
            value={{
                ...value,
                instanceLanguages,
                instanceDefaultLanguage,
                loaded: true,
            }}
        >
            {children}
        </TranslationsContext.Provider>
    );
};

export { TranslationsProvider };
